import { FC, ComponentProps } from 'react';
import { StyledButton } from '../StyledButton';

type Props = {
  show?: boolean;
  onClickCallback?: () => void;
  label?: string;
  addMarginRight?: boolean;
} & ComponentProps<typeof StyledButton>;

export const CancelButton: FC<Props> = ({ show, onClickCallback, label, addMarginRight, ...otherProps }) => {
  return (
    <StyledButton
      variant=" "
      onClick={onClickCallback}
      display={show ? '' : 'none'}
      aria-hidden={!show}
      width="fit-content !important"
      marginTop="0"
      marginRight={addMarginRight ? '16px !important' : '0px !important'}
      px="16px !important"
      py="12px !important"
      color="secondary.1"
      {...otherProps}
    >
      {label}
    </StyledButton>
  );
};